import styled from 'styled-components';
import { zBanners } from '~/styled/z-index';

export const INCIDENT_BANNER_HEIGHT = 54;

export const BannerWrapperDiv = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  min-height: ${INCIDENT_BANNER_HEIGHT}px;
  flex-shrink: 0;
  z-index: ${zBanners};
`;
